import template from './enquiriesBreakdown.html';
import controller from './enquiriesBreakdown.controller';
import './enquiriesBreakdown.styl';

let enquiriesBreakdownComponent = {
  restrict: 'E',
  bindings: {
    title: '<',
    chartTitle: '<',    
    data: '<',
    event: '@',
    identifiers: '<'
  },
  template,
  controller
};

export default enquiriesBreakdownComponent;



// WEBPACK FOOTER //
// ./client/app/components/leadMonitor/enquiriesBreakdown/enquiriesBreakdown.component.js